module.exports = __webpack_public_path__ + "media/pedro.1580ad6a.mp3";